export default __webpack_public_path__ + "static/media/hht2_ep20_speaking_03.2cb52937.png";